import gql from 'graphql-tag'
export default gql`
  mutation removeUser($token: String!, $userId: Int!) {
    removeUser(userId: $userId, token: $token)
  }
`
